// src/pages/CguPage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Footer from '../components/Footer';

const CguPage = () => {
  const { t, i18n } = useTranslation();
  const isNotFr = i18n.language !== 'fr';

  return (
    <div className="pt-24 pb-12">
      <Helmet>
        <title>{t('legal.cgu.meta.title')}</title>
        <meta name="description" content={t('legal.cgu.meta.description')} />
        <link rel="canonical" href="https://hmonghearts.com/cgu" />
      </Helmet>
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl font-bold mb-8 dark:text-gray-100">{t('legal.cgu.title')}</h1>

        {isNotFr && (
          <div className="mb-6 p-4 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 rounded-xl text-sm text-amber-800 dark:text-amber-200">
            {t('legal.disclaimer')}
          </div>
        )}

        <div className="prose prose-gray max-w-none space-y-6 text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article1.title')}
            </h2>
            <p>
              {t('legal.cgu.article1.p1')}{' '}
              <a
                href="https://hmonghearts.com"
                className="text-rose-600 dark:text-rose-400 hover:underline"
              >
                hmonghearts.com
              </a>
              .
            </p>
            <p>{t('legal.cgu.article1.p2')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article2.title')}
            </h2>
            <p>{t('legal.cgu.article2.p1')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article3.title')}
            </h2>
            <p>{t('legal.cgu.article3.p1')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li dangerouslySetInnerHTML={{ __html: t('legal.cgu.article3.item1') }} />
              <li>{t('legal.cgu.article3.item2')}</li>
              <li>{t('legal.cgu.article3.item3')}</li>
              <li>{t('legal.cgu.article3.item4')}</li>
            </ul>
            <p className="mt-2" dangerouslySetInnerHTML={{ __html: t('legal.cgu.article3.p2') }} />
            <p className="mt-2" dangerouslySetInnerHTML={{ __html: t('legal.cgu.article3.p3') }} />
            <p className="mt-2">{t('legal.cgu.article3.p4')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article4.title')}
            </h2>
            <p>{t('legal.cgu.article4.p1')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li dangerouslySetInnerHTML={{ __html: t('legal.cgu.article4.item1') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.cgu.article4.item2') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.cgu.article4.item3') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.cgu.article4.item4') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.cgu.article4.item5') }} />
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article5.title')}
            </h2>
            <p>{t('legal.cgu.article5.p1')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li>{t('legal.cgu.article5.item1')}</li>
              <li>{t('legal.cgu.article5.item2')}</li>
              <li>{t('legal.cgu.article5.item3')}</li>
              <li>{t('legal.cgu.article5.item4')}</li>
              <li>{t('legal.cgu.article5.item5')}</li>
              <li>{t('legal.cgu.article5.item6')}</li>
              <li>{t('legal.cgu.article5.item7')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article6.title')}
            </h2>
            <p>{t('legal.cgu.article6.p1')}</p>
            <p>{t('legal.cgu.article6.p2')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article7.title')}
            </h2>
            <p>{t('legal.cgu.article7.p1')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article8.title')}
            </h2>
            <p>{t('legal.cgu.article8.p1')}</p>
            <p>
              {t('legal.cgu.article8.p2')}{' '}
              <a
                href="mailto:contact@hmonghearts.com"
                className="text-rose-600 dark:text-rose-400 hover:underline"
              >
                contact@hmonghearts.com
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article9.title')}
            </h2>
            <p>{t('legal.cgu.article9.p1')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article10.title')}
            </h2>
            <p>{t('legal.cgu.article10.p1')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li>{t('legal.cgu.article10.item1')}</li>
              <li>{t('legal.cgu.article10.item2')}</li>
              <li>{t('legal.cgu.article10.item3')}</li>
              <li>{t('legal.cgu.article10.item4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article11.title')}
            </h2>
            <p>{t('legal.cgu.article11.p1')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article12.title')}
            </h2>
            <p>{t('legal.cgu.article12.p1')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.cgu.article13.title')}
            </h2>
            <p>{t('legal.cgu.article13.p1')}</p>
          </section>

          <p className="text-gray-400 text-xs mt-8">{t('legal.cgu.lastUpdated')}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CguPage;
